import { ContactRoundIcon, FileTextIcon, SearchIcon, ShoppingCart, WrenchIcon } from 'lucide-react'

import {NavGroup} from './types'

import { paths } from '@/config/path'

export const data: {[key: string]: NavGroup[]} = {
  technician: [
    {
      title: '',
      items: [
        {
          title: 'Commandes',
          icon: FileTextIcon,
          items: [
            { title: 'Mes commandes', url: paths.app.orders.getHref() },
            { title: 'Saisir une commande', url: paths.app['new-order-solo'].getHref() },
          ],
        },
        {
          title: 'Services',
          icon: WrenchIcon,
          items: [
            { title: 'Mes services', url: paths.app.services.getHref() },
            { title: 'Questions associées', url: paths.app['service-questions'].getHref() },
          ],
        },
      ],
    },
  ],
  practician: [
    {
      title: '',
      items: [
        {title: 'Commandes', icon: ShoppingCart, url: paths.app.orders.getHref()},
        {title: 'Trouver un service', icon: SearchIcon, url: paths.app['search-service'].getHref({})},
        {title: 'Fiches patients', icon: ContactRoundIcon, url: paths.app['my-patients'].getHref()}
      ]
    }
  ]
}